import React, { useState, useEffect } from "react";
import { PlantingTree } from "../../component/ecovestwelcome/PlantingTree";
import "./style.css";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from "axios";

const EarnXp = () => {
    const user = useSelector(state => state.auth.user);
    const { id } = user.claims;
    const investorId = id && id.toString();
  const navigate = useNavigate();
  const [objectives, setObjectives] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchObjectives = async () => {
      try {
        const response = await axios.get(`${apiUrl}/ecovest/earnxp/${investorId}`);
        if (response.data.status.code === 1) {
          setObjectives(response.data.data[0]); // Extract the array from the data
        }
      } catch (error) {
        console.error("Error fetching objectives:", error);
      } 
    };

    fetchObjectives();
  }, [apiUrl]);


  return (
    <div className="earn-XP">
      <div className="div d-flex flex-column justify-content-center align-items-start w-75 my-4">
        <div className="objectives-wrapper d-flex justify-content-between w-100">
          <div className="objectives">OBJECTIVES</div>
          <button className="button" onClick={() => navigate(-1)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="note gap-2 px-2 py-1 mt-3">
          <div className="XP-container-2">
            <img className="img" alt="Green coin" src="/assets/images/ecovestearnxp/green-coin-5.svg" />
            <div className="XP-text-2">1000 XP</div>
          </div>

          <div className="title-2">=</div>

          <PlantingTree
            className="planting-tree-available-trees"
            divClassName="planting-tree-instance"
            image="/assets/images/ecovestwelcomeimg/image-86-1.png"
            text="(1)"
          />
        </div>

        <div className="d-flex flex-column align-items-start w-100 gap-5 mt-3 p-0">
          {objectives.map((theobjective) => (
            <div className="container-2 d-flex flex-lg-row flex-md-row flex-column p-4 w-100 gap-4" key={theobjective.id}>
              <div className="text-container col-lg-6 col-md-6 col-12">
                <div className="title">{theobjective.title}</div>
                <p className="description">{theobjective.descriptionXp}</p>
              </div>

              {/* Progress or action button based on objective type */}
              {theobjective.id === 1 && <div className="progress-xp">{theobjective.myObjective}/{theobjective.objective}</div>}
              {theobjective.id === 2 && <div className="progress-xp">{theobjective.myObjective}/{theobjective.objective}</div>}
              {theobjective.id === 3 && (
                <div className="right-icon">
                  <button className="button-2">Share now</button>
                </div>
              )}
              {theobjective.id === 4 && (
                <div className="right-icon">
                  <button className="button-2">Let's go</button>
                </div>
              )}
              {theobjective.id === 5 && <div className="progress-xp">{theobjective.myObjective}/{theobjective.objective}</div>}

              <div className="XP-container">
                <img
                  className="green-coin"
                  alt="Green coin"
                  src={`/assets/images/ecovestearnxp/green-coin-${theobjective.id}.svg`}
                />
                <div className="XP-text">{theobjective.xp} XP</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EarnXp;